"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.medium = exports.small = exports.disabled = exports.transparent = exports.secondary = exports.primary = void 0;

var _theme = require("../../styles/theme");

var primary = "\n  border-color: ".concat(_theme.colors.blue.primaryDark, ";\n  background-color: ").concat(_theme.colors.blue.primary, ";\n  color: ").concat(_theme.colors.white, ";\n  &:hover {\n    background-color: ").concat(_theme.colors.blue.primaryLight, ";\n  }\n");
exports.primary = primary;
var secondary = "\n  border-color: ".concat(_theme.colors.blue.secondaryDark, ";\n  background-color: ").concat(_theme.colors.blue.secondaryLight, ";\n  color: ").concat(_theme.colors.blue.primary, ";\n  &:hover {\n    background-color: ").concat(_theme.colors.blue.secondary, ";\n  }\n");
exports.secondary = secondary;
var transparent = "\n  color: ".concat(_theme.colors.blue.primary, ";\n  &:hover {\n    text-decoration: underline;\n  }\n");
exports.transparent = transparent;
var disabled = "\n  transition: none;\n  cursor: not-allowed;\n  background: ".concat(_theme.colors.grey.secondaryDark, " !important;\n  border-color: ").concat(_theme.colors.grey.secondaryDark, ";\n  color: ").concat(_theme.colors.grey.secondaryLight, ";\n");
exports.disabled = disabled;
var small = "\n  line-height: 28px;\n  height: 30px;\n  padding: 0 9px;\n";
exports.small = small;
var medium = "\n  line-height: 38px;\n  height: 40px;\n  padding: 0 12px;\n";
exports.medium = medium;